import { api } from '@/lib/api';
import type { DashboardPayload, DashboardQuery } from './types';

/**
 * PRD §5.9 — one endpoint for the whole screen.
 *
 * There is deliberately no second call here: COST-16 means the client must
 * never try to widen what it was given, so the dashboard asks once and renders
 * the answer.
 */
export const dashboardApi = {
  get: (params: DashboardQuery) =>
    api.get<DashboardPayload>('/dashboard', { params }).then((response) => response.data),
};

export const dashboardKeys = {
  all: ['dashboard'] as const,
  summary: (params: DashboardQuery) => [...dashboardKeys.all, 'summary', params] as const,
};
